<template>
    <form>
        <div class="row">
            <div class="col-lg-10">
                <div class="row">
                    <div class="col-lg-12 mt-2">
                            <!-- additional docs -->
                    <h4 class="card-title">Addition Documents</h4>
                      <div class="inline my-2 form-group file-group border-light" v-for="(item, index) in EvaluationForm.model.eudcomments" :key="'result_'+index" style="width:100%">
                        <div style="width:50%">
                        <input class="" type="text" v-model="item.result" />
                        </div>
                        <div class="mt-2 ml-2">
                          <upload-file
                            v-if="EvaluationForm.initialized"
                            v-model="EvaluationForm.files.eudcomments['cnEudDocs' + (index+1)]"
                            class="upload-file"
                            :file-data="EvaluationForm.files.eudcomments['cnEudDocs' + (index+1)]"
                            :is-editable="EvaluationForm.isEditable"
                            :section="'eudcomments.cnEudDocs' + (index + 1)"
                            
                            >
                          </upload-file>
                          <!--@file="fileAdded"-->
                        </div>
                        <span class="msd-remove-item tim-icons icon-trash-simple ml-4 deleterow" @click="removeSupportField(EvaluationForm.model.eudcomments, index)" v-if="EvaluationForm.isEditable"></span>
                      </div>

                  <base-button
                    type="primary"
                    @click.native="addOtherDocument"
                    class=""
                    >
                    <i class="tim-icons icon-simple-add mr-2"></i> {{$t('small_technical_grants.logical_framework__add_row_button_title')}}
                  </base-button>
                </div>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import { EvaluationForm } from "@/services";
import InfoRight from "./InfoRight";
import ApplicationInfo from "../ApplicationInfo";
import { CommentBox } from "src/components";
import { Select, Option } from "element-ui";

export default {
    components: {
        ApplicationInfo,
        InfoRight,
        CommentBox,
        loggedUser:{},
        [Select.name]: Select,
        [Option.name]: Option
    },
    data() {
        return {
            EvaluationForm,
            downloadFiles: [
                {
                    en:
                        "/files/en/RRG/Annex 5 Small Technical Grant for Assessment Evaluation Grid.docx",
                    fr:
                        "/files/en/RRG/Annex 5 Small Technical Grant for Assessment Evaluation Grid.docx"
                }
            ]
        };
    },
    created() {
      this.loggedUser = this.$store.getters['Auth/loggedUser']; 
    },
    beforeCreate() {
        if (!EvaluationForm.files.eudcomments) {
            EvaluationForm.files.eudcomments = {};
        }
    },
    mounted() {
      let vm =this;
      if(!vm.EvaluationForm.model.eudcomments){
        vm.EvaluationForm.model.eudcomments = [];
      }
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate() {
            return this.$validator.validateAll().then(res => {
                this.$emit("on-validated", res, this.model);
                return res;
            });
        },
        addOtherDocument()
      {
        if (!EvaluationForm.model.eudcomments)
        {
          EvaluationForm.model.eudcomments = [];
        }

        EvaluationForm.model.eudcomments.push({});
        this.$forceUpdate();
      },
      removeSupportField(subgroup, index)
            {
                if (confirm(this.$t('monitoring.confirm__remove_field')))
                {
                    subgroup.splice(index, 1);
                }
            },
    }
};
</script>
<style scoped>
textarea {
    resize: vertical !important;
}
</style>
